document.addEventListener('DOMContentLoaded', function () {
  const checkoutButton = document.getElementById('checkout');
  let isInternationalOrder = false;

  // Your existing checkout button delay
  checkoutButton.disabled = true;
  setTimeout(function () {
    checkoutButton.disabled = false;
  }, 5000);

  // International shipping agreement handler
  function handleShippingAgreement(countryCode) {
    const shippingAgreement = document.getElementById('shipping-agreement');
    
    if (countryCode !== 'SG') {
      isInternationalOrder = true;
      shippingAgreement.style.display = 'block';
      
      // Add required validation for international orders
      addCheckoutValidation();
    }
  }

  function addCheckoutValidation() {
    // Find all forms that submit to cart/checkout
    const cartForms = document.querySelectorAll('form[action="/cart"], form[action*="cart"]');
    
    cartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        if (isInternationalOrder) {
          const checkbox = document.getElementById('shipping-policy-checkbox');
          if (!checkbox || !checkbox.checked) {
            e.preventDefault();
            e.stopPropagation();
            showValidationError();
            return false;
          }
        }
      });
    });

    // Also add click validation to checkout button specifically
    checkoutButton.addEventListener('click', function(e) {
      if (isInternationalOrder) {
        const checkbox = document.getElementById('shipping-policy-checkbox');
        if (!checkbox || !checkbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          showValidationError();
          return false;
        }
      }
    });

    // Add validation to dynamic checkout buttons as well
    const dynamicButtons = document.querySelectorAll('.additional-checkout-buttons button, .additional-checkout-buttons input[type="submit"]');
    dynamicButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        if (isInternationalOrder) {
          const checkbox = document.getElementById('shipping-policy-checkbox');
          if (!checkbox || !checkbox.checked) {
            e.preventDefault();
            e.stopPropagation();
            showValidationError();
            return false;
          }
        }
      });
    });
  }

  function showValidationError() {
    // Remove any existing error messages
    const existingError = document.querySelector('.shipping-error');
    if (existingError) existingError.remove();
    
    // Create error message
    const errorDiv = document.createElement('div');
    errorDiv.className = 'shipping-error';
    errorDiv.style.cssText = `
      background: #ffebee;
      border: 1px solid #f44336;
      color: #c62828;
      padding: 12px;
      border-radius: 4px;
      margin: 10px 0;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
    `;
    errorDiv.innerHTML = '⚠️ Please agree to the international shipping terms before proceeding to checkout.';
    
    // Insert error above the shipping agreement
    const agreement = document.getElementById('shipping-agreement');
    agreement.parentNode.insertBefore(errorDiv, agreement);
    
    // Scroll to error
    errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
    // Remove error after 7 seconds
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 7000);
  }

  // Detect country using Shopify's localization data (set in main-cart-footer.liquid)
  const countryCode = window.shopifyCountryCode || 'SG';
  handleShippingAgreement(countryCode);
});